const TEST_UNO_PATTERN = /-test$/i

export function isTestUno(uno: unknown): boolean {
  return typeof uno === 'string' && TEST_UNO_PATTERN.test(uno)
}
